<template>
  <a-auto-complete
    v-model="innerValue"
    @select="inputValue"
    @change="getShipNameList"
  >
    <template slot="dataSource">
      <a-select-opt-group v-if="shipNameList.length>0" :key="1">
        <span slot="label">
          <a-pagination style="position: absolute;right: 4px" v-model.trim="current" :total="total" show-less-items @change="getShipNameList"/>
        </span>
        <a-select-option v-for="name in shipNameList" :key="name">
          {{ name }}
        </a-select-option>
      </a-select-opt-group>
    </template>
  </a-auto-complete>
</template>

<script>
export default {
  name: 'ship-select',
  props: {
    value: { type: String },
  },
  data () {
    return {
      innerValue: '',
      shipNameList: [],
      current: 1,
      total: 0,
    };
  },
  methods: {
    inputValue (value) {
      this.$emit('input', value);
    },
    getShipNameList (value) {
      this.$emit('input', value);
      if (!value) return true;
      let condition = [
        {
          "GET_HEAD": [{ "GET_METHOD": 1, "GET_TABLE": "GM_INPUT_PROMPT", "BEGIN_ROW_NO": this.current, "GET_ROW_CNT": 10, "SORT_FIELD": "UPDATE_DATE" }],
          "GET_FILTER": [
            { "FILTER_FIELD": "PROMPT_CONTENT", "FILTER_TYPE": 4, "FILTER_VALUE1": value, "FILTER_VALUE2": '' },
            { "FILTER_FIELD": "INPUT_TYPE", "FILTER_TYPE": "1", "FILTER_VALUE1": 0, "FILTER_VALUE2": '' },
            { "FILTER_FIELD": "STATUS", "FILTER_TYPE": "1", "FILTER_VALUE1": 1, "FILTER_VALUE2": '' }
          ]
        }];
      this.$h5Api({
        type: '1001',
        data: condition,
        showMessage: false,
        loading: false,
      }).then(data => {
        let list = []
        data.data['DATA_LIST'].forEach(item => {
          list.push(item.PROMPT_CONTENT)
        })
        this.shipNameList = list
        this.total = list.length
      })
    },
  }
}
</script>